import { useFetcher } from "@remix-run/react";
import { useContext, useEffect } from "react";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { type loader as serviceSelectLoader } from "~/routes/resources+/book+/service-select";
import { route } from "~/utils/route";
import { MultiSelectCard } from "~/components/ui/multi-select-card";
import { Label } from "@radix-ui/react-label";
import { cn } from "~/utils/shadcn";

export function ServiceSelect() {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const {
    selectedServiceIds,
    setSelectedServiceIds,
    selectedBarberId,
    setSelectedDate,
    setSelectedTime,
  } = context;

  const serviceSelectFetcher = useFetcher<typeof serviceSelectLoader>();

  useEffect(() => {
    serviceSelectFetcher.load(
      route("/resources/book/service-select", { barberId: selectedBarberId })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBarberId]);

  return (
    <div>
      <Label className="px-6" htmlFor="service-select">
        Services
      </Label>
      <div className="px-6 text-sm text-white/70">Choose multiple services</div>
      <div className="mt-2" />

      <MultiSelectCard.Root
        className="px-6"
        value={selectedServiceIds}
        onChange={(newOptions) => {
          setSelectedServiceIds(Array.from(newOptions, (option) => option.id));
          setSelectedDate("");
          setSelectedTime("");
        }}
      >
        {!selectedBarberId ? (
          <MultiSelectCard.Card disabled value="" className="w-full">
            <span>Complete fields above</span>
          </MultiSelectCard.Card>
        ) : (
          serviceSelectFetcher.data?.services.map((service) => (
            <MultiSelectCard.Card
              key={service.id}
              value={service.id}
              className={cn(
                selectedServiceIds.includes(service.id) ? "pr-20" : "px-10"
              )}
            >
              {service.name}
            </MultiSelectCard.Card>
          ))
        )}
      </MultiSelectCard.Root>
    </div>
  );
}
